import React, { MouseEvent, useState } from 'react';
import { IconButton, Menu, MenuItem } from '@material-ui/core';
import { MoreVert } from '@material-ui/icons';

export interface DataGrableHeaderMenuAction {
  title: string;
  isAvailable: boolean;
  action: () => void;
}

export interface DataGrableHeaderMenuActionsProps {
  actions: DataGrableHeaderMenuAction[];
  disabled?: boolean;
}

export function DataGrableHeaderMenuActions({ actions, disabled = false }: DataGrableHeaderMenuActionsProps) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  function handleOpen(event: MouseEvent<HTMLButtonElement>) {
    event.preventDefault();
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  }

  function handleClose(event: MouseEvent<HTMLButtonElement>) {
    event.preventDefault();
    event.stopPropagation();
    setAnchorEl(null);
  }

  return (
    <>
      <IconButton size="small" onClick={handleOpen} data-testid="data-grid-menu-action" disabled={disabled}>
        <MoreVert />
      </IconButton>
      {anchorEl && (
        <Menu anchorEl={anchorEl} open={true} onClose={handleClose}>
          {actions.map(({ title, action, isAvailable }, index) => {
            return (
              <MenuItem
                key={index}
                onClick={() => {
                  action();
                  setAnchorEl(null);
                }}
                disabled={!isAvailable}
                data-testid="data-grid-header-menu-item"
              >
                {title}
              </MenuItem>
            );
          })}
        </Menu>
      )}
    </>
  );
}
